<script>
import SkmStatistik from '@/components/dashboard/skm/Statistik.vue'
import SkmPerInstansiChart from '@/components/dashboard/skm/PerInstansiChart.vue'
import SkmInstansiTriwulanTable from '@/components/dashboard/skm/InstansiTriwulanTable.vue'
import SkmDemografiResponden from '@/components/dashboard/skm/DemografiResponden.vue'
import SkmUnsurPelayanan from '@/components/dashboard/skm/UnsurPelayanan.vue'
import SkmSaranTop10 from '@/components/dashboard/skm/SaranTop10.vue'

export default {
   components: {
      SkmStatistik,
      SkmPerInstansiChart,
      SkmInstansiTriwulanTable,
      SkmDemografiResponden,
      SkmUnsurPelayanan,
      SkmSaranTop10,
   },
}
</script>

<template>
   <div>
      <SkmStatistik />

      <b-row class="mt-1">
         <b-col cols="12" lg="6" class="mb-1">
            <SkmPerInstansiChart class="mt-1" />
         </b-col>
         <b-col cols="12" lg="6" class="mb-1">
            <SkmInstansiTriwulanTable class="mt-1" />
         </b-col>
      </b-row>

      <b-row class="mt-1">
         <b-col cols="12">
            <SkmDemografiResponden />
         </b-col>
      </b-row>

      <b-row class="mt-1">
         <b-col cols="12" lg="6" class="mb-1">
            <SkmUnsurPelayanan />
         </b-col>
         <b-col cols="12" lg="6" class="mb-1">
            <SkmSaranTop10 />
         </b-col>
      </b-row>
   </div>
</template>

<style scoped></style>
